module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1013-b84472d4041520effa8fcbbc8806859a.png";